import api from '..'

const getAccess = () => {
  return api.get('admin/can_access').then(({ data }) => data)
}

export default getAccess
